import { render, staticRenderFns } from "./InboxAvatarPart.vue?vue&type=template&id=1286557a"
import script from "./InboxAvatarPart.vue?vue&type=script&lang=js"
export * from "./InboxAvatarPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports